@if (!hideHeader) {
  <nav class="navbar navbar-expand-lg navbar-expand-md sticky-top navbar-expand-sm">
    <a class="navbar-brand" routerLink="/support-users/all" (click)="onNavigationAttempt('/support-users/all', $event)">
      <img class="align-image" alt="Fluidra logo" src="assets/img/fluidra_pool_logo.svg">
    </a>
    @if (showNavbar) {
      <div>
        <ul class="navbar-nav me-auto">
          
          <li class="nav-item align-name">
            <a [class.active-class]='isBusinessTab' [routerLink]="['/businesses/list']" class="nav-link"
              (click)="checkTabRoute('/businesses/list')">
              {{'lang.businesses' | translate}}
            </a>
          </li>
          <li class="nav-item align-name">
            <a [class.active-class]='isUsersTab' [routerLink]="['/support-users/all']" class="nav-link"
              (click)="onNavigationAttempt('/support-users/all', $event)">
              {{'lang.users' | translate}}
            </a>
          </li>
          <li class="nav-item">
            <a [class.active-class]='isSitesTab' [routerLink]="['/sites/list']" class="nav-link"
              (click)="onNavigationAttempt('/sites/list', $event)">
              {{'lang.sites' | translate}}
            </a>
          </li>
          <li class="nav-item">
            <a [class.active-class]='isEquipmentsTab' [routerLink]="['/equipment/list']" class="nav-link"
              (click)="onNavigationAttempt('/equipment/list', $event)">
              {{'lang.equipment' | translate}}
            </a>
          </li>
        </ul>
      </div>
    }
    <div>
      <ul class="navbar-nav">
        <li class="nav-item dropdown" dropdown>
          <button id="button-basic" type="button" class="btn" aria-controls="dropdown-basic" dropdownToggle>
            <div class="profiler-menu">
              {{initialsToDisplay}}
            </div>
          </button>
          <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu custom-dropdown-menu show" role="menu"
            aria-labelledby="button-basic">
            <li role="menuitem">
              <a class="dropdown-item" (click)="signOut()">
                {{'lang.sign_out' | translate}}
              </a>
            </li>
            <div class="portal-version"> Version : {{portalVersion}}</div>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
}